import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import MenuPopup from "@streeteasy/design-system/legacy/MenuPopup";
import {
  Body,
  Caps,
  SecondarySmall
} from "@streeteasy/design-system/typography/Typography";

import { adProductsIcon } from "./assets";

export const CaretIcon = styled.i.attrs({
  className: "fa fa-angle-down"
})``;

export const StyledMenuPopup = styled(MenuPopup)`
  position: absolute;
  right: -10px;
  top: 100%;
  width: 220px;
  z-index: 10;
`;

export const Callout = styled(Caps)`
  color: ${colors.primaryTouched};
  font-style: italic;
  height: 2.81%;
  position: absolute;
  right: 135px;
  top: 12px;
  width: 5.69%;
`;

export const Pill = styled.span`
  background-color: ${colors.accent2};
  border-radius: 11px;
  color: ${colors.whaleGrey};
  display: inline-block;
  font-size: 11px;
  font-weight: bold;
  line-height: 20px;
  margin: 0 0 0 5px;
  padding: 0 8px;
  position: relative;
  text-transform: uppercase;
  && {
    position: absolute;
    right: 14px;
    top: 9px;
  }
`;

export const PopUpListItem = styled.li`
  margin: 0 -15px;
  position: relative;
`;

export const PopUpContent = styled(SecondarySmall)`
  color: ${colors.goatGrey};
  font-size: 10px;
  font-weight: 700;
  line-height: 10px;
  margin: 10px 15px;
  text-transform: uppercase;
`;

export const AdvertiseBanner = styled.a`
  align-items: center;
  background: ${colors.secondary};
  display: flex;
  height: 90px;
  margin: 14px auto 20px;
  overflow: hidden;
  padding: 0 0 0 18px;
  position: relative;
  width: 180px;

  &:hover,
  &:active,
  &:focus {
    text-decoration: none;
  }
`;

export const AdvertiseContent = styled.div`
  padding: 5px 0 0;
  position: relative;
  z-index: 1;
`;

export const AdvertiseTitle = styled(Body)`
  display: block;
  font-size: 16px;
  line-height: 20px;
  margin: 0 0 4px;
`;

export const AdvertiseBody = styled.span`
  color: ${colors.primary};
  display: block;
  font-size: 12px;
  font-weight: 600;
  line-height: 15px;
  text-transform: uppercase;
`;

export const AdvertiseProductsIcon = styled.img.attrs({
  src: adProductsIcon,
  alt: "ad products"
})`
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;
